import { IMigratableAccount } from './models';

/**
 * Case-insensitive filter over Foundation ID, account name and the name/email of any source user.
 * An empty (or whitespace-only) filter returns the input unchanged.
 */
export function filterAccounts(accounts: IMigratableAccount[], filterText: string): IMigratableAccount[]
{
	const text = (filterText ?? '').trim().toLowerCase();
	if (!text)
	{
		return accounts;
	}

	return accounts.filter(a =>
		a.FoundationId?.toLowerCase().includes(text)
		|| a.AccountName?.toLowerCase().includes(text)
		|| a.SourceUsers?.some(u => u.Email?.toLowerCase().includes(text) || u.Name?.toLowerCase().includes(text)));
}
